import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useStateSelector } from '../../../store/selectors';
import { LoadUserSummaryFromStorage } from '../../../slices/user-summary/load-user-summary-from-storage';
import { LoadLimitsFromStorage } from '../../../slices/current-user/load-limits-from-storage.thunk';
import { LoadLimits } from '../../../slices/current-user/load-limits.thunk';
import { LEFT_MENU_USE_DEFAULT } from './LeftMenu.constants';
import { DefaultMenu } from './DefaultMenu';
import { RoleMenuSwitcher } from './RoleMenuSwitcher';

export const LeftMenu = () => {
    const dispatch = useDispatch() as any;
    const summary = useStateSelector((state) => state.userSummary.summary);
    const limits = useStateSelector((state) => state.currentUser.limits);

    useEffect(() => {
        dispatch(LoadUserSummaryFromStorage());
        dispatch(LoadLimitsFromStorage()).then((response: any) => {
            if (!response.payload) {
                return dispatch(LoadLimits());
            }
            return response;
        });
    }, [dispatch]);

    if (!summary || !limits) {
        return null;
    }

    return LEFT_MENU_USE_DEFAULT ? (
        <DefaultMenu />
    ) : (
        <RoleMenuSwitcher user={summary} limits={limits} />
    );
};
